export default {
  Meta: [
    {
      'http-equiv': 'X-UA-Compatible',
      content: 'IE=edge'
    },
    {
      name: 'viewport',
      content: 'width=device-width,initial-scale=1.0'
    }
  ],
  Label: {
    companyName: '会社名'
  },

  DefaultFaviconPath: '/static/favicon/favicon.ico?var=20200601',

  MaxCategories: () => { return 10 },
  MaxCodeItems: () => { return 5000 },
  MaxFreewordItems: () => { return 5000 },
  ResponseCode: {
    // 正常終了
    SUCCESS: 200000,
    // validateエラー
    VALIDATE_ERROR: 400000,
    // 営業時間外
    OUT_OF_SERVICE: 400100,
    // 同時ログインによるログアウト
    FORCE_LOGOUT: 400200,
    // 権限不足
    WITHOUT_AUTH: 400300,
    // システムエラー
    SYSTEM_ERROR: 500000
  },
  Weeks: [
    { name: '日', text: '日曜日', value: 0 },
    { name: '月', text: '月曜日', value: 1 },
    { name: '火', text: '火曜日', value: 2 },
    { name: '水', text: '水曜日', value: 3 },
    { name: '木', text: '木曜日', value: 4 },
    { name: '金', text: '金曜日', value: 5 },
    { name: '土', text: '土曜日', value: 6 }
  ],
  ROLES: {
    TD_ADMIN: 1,
    RETAIL_ADMIN: 2,
    RETAIL_USER: 3,
    TRADER_ADMIN: 4,
    TRADER_USER: 5
  },
  AnalyzeMode: {
    //  グループ登録・編集
    IF00000: {
      term: 'E',
      product: 'T',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00001: { // 買上明細集計(ID-POS)
      term: 'B',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: 'B',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 2,
      priceRange: false
    },
    IF00002: { // 性年代別購入者分析
      term: 'B',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: true,
      nonMember: 0,
      priceRange: false
    },
    IF00003: { // ABCL分析
      term: 'B',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: true,
      nonMember: 1,
      priceRange: false
    },
    IF00004: { // トライアルリピート分析
      term: 'B',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: true,
      nonMember: 1,
      priceRange: false
    },
    IF00005: { // トレンド分析
      term: 'B',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: true,
      nonMember: 0,
      priceRange: false
    },
    IF00006: { // バスケット分析
      term: 'B',
      product: 'B',
      shop: 'A',
      member: 'A',
      aggregate: 'B',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: true,
      nonMember: 2,
      priceRange: false
    },
    IF00007: { // 併買分析
      term: 'B',
      product: 'B',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: true,
      nonMember: 0,
      priceRange: false
    },
    IF00008: { // カード会員サマリ
      term: 'B',
      product: '',
      shop: 'A',
      member: 'B',
      aggregate: 'C',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 1,
      priceRange: false
    },
    IF00009: { // 買上明細集計(POS)
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: true,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00010: { // 商品別売上分析
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: true,
      graph: true,
      nonMember: 0,
      priceRange: false
    },
    IF00011: { // ABC分析
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: true,
      graph: true,
      nonMember: 0,
      priceRange: false
    },
    IF00012: { // 分類商品推移表
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: true,
      graph: true,
      nonMember: 0,
      priceRange: false
    },
    IF00013: { // 商品別自社シェア分析
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: true,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00014: { // 明細ダウンロード
      term: '',
      product: '',
      shop: '',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00015: { // マスタダウンロード
      term: '',
      product: '',
      shop: '',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00016: { // 任意ダウンロード(ID-POS)
      term: 'E',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: 'B',
      aggregateList: true,
      groupbyList: false,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00017: { // 任意ダウンロード(POS)
      term: 'E',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00018: { // 在庫分析（在庫レポート）
      term: '',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00019: { // 新商品分析
      term: 'D',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00020: { // 価格帯別分析
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: true
    },
    IF00021: { // 取引先別商品分析
      term: 'A',
      product: 'A',
      shop: 'A',
      member: '',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: true,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00022: { // 稼働顧客属性
      term: 'B',
      product: '',
      shop: 'A',
      member: 'C',
      aggregate: 'C',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00023: { // 購入回数別分布
      term: 'B',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00024: { // カード会員サマリレポート(全社計)
      term: 'F',
      product: '',
      shop: '',
      member: '',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00025: { // 購入者非購入者因数分解
      term: 'E',
      product: 'A',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00026: { // ABCL分析(全国パネル比較)
      term: 'F',
      product: '',
      shop: '',
      member: '',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00027: { // デシル分析
      term: 'B',
      product: '',
      shop: 'A',
      member: 'D',
      aggregate: 'C',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00028: { // ランク分析
      term: 'B',
      product: '',
      shop: 'A',
      member: 'D',
      aggregate: 'C',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00029: { // トライアルリピート（全国パネル比較）
      term: 'F',
      product: '',
      shop: '',
      member: '',
      aggregate: '',
      aggregateList: false,
      groupbyList: false,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    },
    IF00030: { // 顧客構造図
      term: 'B',
      product: 'B',
      shop: 'A',
      member: 'A',
      aggregate: '',
      aggregateList: true,
      groupbyList: true,
      zeroData: false,
      graph: false,
      nonMember: 0,
      priceRange: false
    }
  },
  AggregateMode: [
    //  mode=0 期間併買
    [
      'base_rank',
      'average_unit_price',
      'purchase_qty',
      'purchase_price',
      'item_purchasers_num',
      'concurrent_buyers_qty',
      'trial_rate',
      'lift_value',
      'buyers_of_target_item_rate',
      'concurrent_purchases_qty',
      'concurrent_purchases_rate',
      'purchasers_qty',
      'buyers_rate',
      'multiple_purchases_rate',
      'purchases_qty',
      'item_purchases_qty',
      'target_item_purchases_qty',
      'target_item_purchasers_qty',
      'target_items_rate',
      'purchase_qty_per_person',
      'purchase_price_per_person',
      'concurrent_purchases_qty_per_person'
    ],
    //  mode=1 直前期間購入者分析
    [
      'base_rank',
      'purchase_qty',
      'purchase_price',
      'item_purchasers_num',
      'non_buyers_of_target_item_qty',
      'buyers_of_target_item_rate',
      'concurrent_buyers_qty',
      'target_item_purchasers_qty',
      'target_items_rate',
      'purchase_qty_per_person',
      'purchase_price_per_person'
    ],
    //  mode=2 直後期間購入者分析
    [
      'base_rank',
      'purchase_qty',
      'purchase_price',
      'item_purchasers_num',
      'concurrent_buyers_qty',
      'non_buyers_of_target_item_qty',
      'non_buyers_of_target_item_qty',
      'buyers_of_target_item_rate',
      'target_item_purchasers_qty',
      'target_items_rate',
      'purchase_qty_per_person',
      'purchase_price_per_person'
    ]
  ],
  GroupByLimitGroup: {
    'IF00003': [// ABCL分析
      [
        'item_cd',
        'item_category_cd1',
        'item_category_cd2',
        'item_category_cd3',
        'item_category_cd4',
        'item_category_cd5',
        'item_category_cd6',
        'item_category_cd7',
        'item_category_cd8',
        'item_category_cd9',
        'item_category_cd10',
        'item_attribute_1',
        'item_attribute_2',
        'item_attribute_3',
        'item_attribute_4',
        'item_attribute_5',
        'item_attribute_6',
        'item_attribute_7',
        'item_attribute_8',
        'item_attribute_9',
        'item_attribute_10'
      ]
    ],
    'IF00004': [// トライアルリピート分析
      [
        'item_cd',
        'item_category_cd1',
        'item_category_cd2',
        'item_category_cd3',
        'item_category_cd4',
        'item_category_cd5',
        'item_category_cd6',
        'item_category_cd7',
        'item_category_cd8',
        'item_category_cd9',
        'item_category_cd10',
        'item_attribute_1',
        'item_attribute_2',
        'item_attribute_3',
        'item_attribute_4',
        'item_attribute_5',
        'item_attribute_6',
        'item_attribute_7',
        'item_attribute_8',
        'item_attribute_9',
        'item_attribute_10'
      ]
    ],
    'IF00005': [// トレンド分析
      [
        'date_yyyy',
        'date_yyyymm',
        'date_yyyymmdd',
        'day_of_week',
        'purchase_time_h',
        'week_start_date'
      ],
      [
        'item_cd',
        'item_category_cd1',
        'item_category_cd2',
        'item_category_cd3',
        'item_category_cd4',
        'item_category_cd5',
        'item_category_cd6',
        'item_category_cd7',
        'item_category_cd8',
        'item_category_cd9',
        'item_category_cd10',
        'store_cd',
        'store_attribute_cd1',
        'store_attribute_cd2',
        'store_attribute_cd3',
        'store_attribute_cd4',
        'store_attribute_cd5',
        'item_attribute_1',
        'item_attribute_2',
        'item_attribute_3',
        'item_attribute_4',
        'item_attribute_5',
        'item_attribute_6',
        'item_attribute_7',
        'item_attribute_8',
        'item_attribute_9',
        'item_attribute_10'
      ]
    ],
    'IF00006': [// バスケット分析
      [
        'jan',
        'item_category_cd1',
        'item_category_cd2',
        'item_category_cd3',
        'item_category_cd4',
        'item_category_cd5',
        'item_category_cd6',
        'item_category_cd7',
        'item_category_cd8',
        'item_category_cd9',
        'item_category_cd10',
        'item_attribute_1',
        'item_attribute_2',
        'item_attribute_3',
        'item_attribute_4',
        'item_attribute_5',
        'item_attribute_6',
        'item_attribute_7',
        'item_attribute_8',
        'item_attribute_9',
        'item_attribute_10'
      ]
    ],
    'IF00007': [// 併買分析
      [
        'base_item_category_cd1',
        'base_item_category_cd2',
        'base_item_category_cd3',
        'base_item_category_cd4',
        'base_item_category_cd5',
        'base_item_category_cd6',
        'base_item_cd',
        'base_item_attribute_1',
        'base_item_attribute_2',
        'base_item_attribute_3',
        'base_item_attribute_4',
        'base_item_attribute_5',
        'base_item_attribute_6',
        'base_item_attribute_7',
        'base_item_attribute_8',
        'base_item_attribute_9',
        'base_item_attribute_10'
      ],
      [
        'target_item_category_cd1',
        'target_item_category_cd2',
        'target_item_category_cd3',
        'target_item_category_cd4',
        'target_item_category_cd5',
        'target_item_category_cd6',
        'target_item_cd',
        'target_item_attribute_1',
        'target_item_attribute_2',
        'target_item_attribute_3',
        'target_item_attribute_4',
        'target_item_attribute_5',
        'target_item_attribute_6',
        'target_item_attribute_7',
        'target_item_attribute_8',
        'target_item_attribute_9',
        'target_item_attribute_10'
      ]
    ],
    'IF00012': [// 分類商品推移表
      [
        'purchase_date',
        'date_mm',
        'day_of_week',
        'week_num_fiscal_year',
        'week_start_date'
      ],
      [
        'item_cd',
        'item_category_cd1',
        'item_category_cd2',
        'item_category_cd3',
        'item_category_cd4',
        'item_category_cd5',
        'item_category_cd6',
        'item_category_cd7',
        'item_category_cd8',
        'item_category_cd9',
        'item_category_cd10'
      ]
    ],
    'IF00008': [// カード会員サマリ
      [
        'store_cd',
        'store_attribute_cd1',
        'store_attribute_cd2',
        'store_attribute_cd3',
        'store_attribute_cd4',
        'store_attribute_cd5'
      ]
    ],
    'IF00030': [// 顧客構造図
      [
        'store_cd',
        'store_category_cd1',
        'store_category_cd2',
        'store_category_cd3',
        'store_category_cd4',
        'store_category_cd5',
        'item_category_cd1',
        'item_category_cd2',
        'item_category_cd3',
        'item_category_cd4',
        'item_category_cd5',
        'item_category_cd6',
        'in_store_product_cd',
        'in_store_product_category_cd1',
        'in_store_product_category_cd2',
        'in_store_product_category_cd3',
        'in_store_product_category_cd4',
        'in_store_product_category_cd5',
        'in_store_product_category_cd6',
        'item_attribute_1',
        'item_attribute_2',
        'item_attribute_3',
        'item_attribute_4',
        'item_attribute_5',
        'item_attribute_6',
        'item_attribute_7',
        'item_attribute_8',
        'item_attribute_9',
        'item_attribute_10',
        'item_cd',
        'member_no',
        'integrate_member_no',
        'masked_member_no',
        'masking_aggregation_membership_number'
      ]
    ]
  },
  GroupByLimitGroupWithTerm: {
    'IF00001': [
      'date_mm',
      'date_yyyymm',
      'purchase_date',
      'day_of_week',
      'purchase_time',
      'week_num_fiscal_year',
      'week_start_date'
    ],
    'IF00004': [
      'date_yyyymm',
      'week_start_date'
    ],
    'IF00005': [
      'date_yyyy',
      'date_yyyymm',
      'date_yyyymmdd',
      'day_of_week',
      'purchase_time_h',
      'week_start_date'
    ],
    'IF00008': [
      'date_yyyy',
      'date_mm',
      'week_start_date',
      'date_dd'
    ],
    'IF00009': [
      'purchase_date',
      'date_mm',
      'day_of_week',
      'week_num_fiscal_year',
      'week_start_date'
    ],
    'IF00012': [
      'purchase_date',
      'date_mm',
      'day_of_week',
      'week_num_fiscal_year',
      'week_start_date'
    ]
  },
  ResultTableFilterSelect: {
    store_cd: true,
    gender: true,
    age_5: true,
    age_10: true,
    store_div: true,
    settlement: true,
    card_type: true,
    sum_row: true,
    item_category_cd1: true,
    item_category_cd2: true,
    item_category_cd3: true,
    item_category_cd4: true,
    item_category_cd5: true,
    item_category_cd6: true,
    item_category_cd7: true,
    item_category_cd8: true,
    item_category_cd9: true,
    item_category_cd10: true,
    store_category_cd1: true,
    store_category_cd2: true,
    store_category_cd3: true,
    store_category_cd4: true,
    store_category_cd5: true,
    store_attribute_cd1: true,
    store_attribute_cd2: true,
    store_attribute_cd3: true,
    store_attribute_cd4: true,
    store_attribute_cd5: true,
    in_store_product_category_cd1: true,
    in_store_product_category_cd2: true,
    in_store_product_category_cd3: true,
    in_store_product_category_cd4: true,
    in_store_product_category_cd5: true,
    in_store_product_category_cd6: true,
    in_store_product_category_cd7: true,
    in_store_product_category_cd8: true,
    in_store_product_category_cd9: true,
    in_store_product_category_cd10: true,
    decile: true,
    rank_cd: true
  }
}
